var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.546 4.98433C11.7247 4.5969 12.2753 4.5969 12.454 4.98433L14.1399 8.63923C14.2127 8.79713 14.3623 8.90585 14.535 8.92633L18.532 9.40023C18.9557 9.45047 19.1258 9.97416 18.8126 10.2638L15.8575 12.9966C15.7299 13.1147 15.6727 13.2906 15.7066 13.4611L16.491 17.4089C16.5742 17.8274 16.1287 18.1511 15.7564 17.9427L12.2442 15.9767C12.0925 15.8918 11.9075 15.8918 11.7558 15.9767L8.24361 17.9427C7.8713 18.1511 7.42583 17.8274 7.50898 17.4089L8.2934 13.4611C8.32729 13.2906 8.27013 13.1147 8.14246 12.9966L5.1874 10.2638C4.87415 9.97416 5.04431 9.45047 5.46801 9.40023L9.46497 8.92633C9.63765 8.90585 9.7873 8.79713 9.86013 8.63923L11.546 4.98433Z",
    fill: "#FFB800"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/StarIcon.9be38c916d156108c4a3306cac026470.svg";
export { ForwardRef as ReactComponent };